module.exports = __webpack_public_path__ + "static/media/peix.880bb3c9.png";